import { useStyles } from "app/app.styles";
import { observer } from "mobx-react";
import { useRootStore } from "app/useRootStore";
import { createBrowserHistory } from "history";
import React from "react";
import { syncHistoryWithStore } from "mobx-react-router";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ApplicationRouter from "shared/routes/ApplicationRouter";
import configureAppInsights from "shared/helpers/configureAppInsights";
import generateDataTestId from "shared/helpers/generateDataTestId";
import initializeReactGA from "shared/helpers/initializeReactGA";

import { AppProviders } from "app/AppProviders";
import ErrorBoundary from "app/ErrorBoundary";
import BootstrapIntercom from "components/bootstrapIntercom";
import BootstrapGoogleAnalytics from "components/bootstrapGoogleAnalytics";

const browserHistory = createBrowserHistory();

configureAppInsights();
initializeReactGA(browserHistory);
generateDataTestId();

// eslint-disable-next-line no-console
console.info(`Version: ${window.APP_VERSION}`);

function App(): JSX.Element {
    const {
        rootStore: { userHomeRoute, routerStore },
    } = useRootStore();
    const history = syncHistoryWithStore(browserHistory, routerStore);
    const classes = useStyles();

    return (
        <div className={classes.main}>
            <AppProviders>
                <ErrorBoundary>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <ApplicationRouter homeRoute={userHomeRoute} history={history} />
                        <BootstrapIntercom />
                        <BootstrapGoogleAnalytics />
                    </MuiPickersUtilsProvider>
                </ErrorBoundary>
            </AppProviders>
        </div>
    );
}

export default observer(App);
